export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_DATA_ITEM = "SET_DATA_ITEM";
export const SET_DATA_LIST = "SET_DATA_LIST";
export const SET_TOTAL = "SET_TOTAL";
export const SET_SELECTED_STUDENT = "SET_SELECTED_STUDENT";
export const SET_PROCESS_STATUSES = "SET_PROCESS_STATUSES";
